<template>
    <default-layout>
        <div class="row">
            <div class="col-12">
                <h1 class="h4 mb-4 clearfix">
                    License playback details
                    <hr>
                </h1>
            </div>
        </div>

        <div class="row" v-if="loading === true">
            <div class="col-12">
                <spinner-component class="p-5" type="spinner-grow"/>
            </div>
        </div>

        <div class="row" v-if="loading === false && sessions.length === 0">
            <div class="col-12">
                <div class="alert alert-info" role="alert">
                    <h4 class="alert-heading">No playback data</h4>
                    <p class="mb-0">This license does not have any playback data associated to it.</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="loading === false && sessions.length > 0">

            <div class="col-12 mb-3">
                <h2 class="h6">Summary</h2>

                <ul class="list-group list-group-horizontal-md">
                    <li class="list-group-item">
                        Total playback time
                        <br>
                        <small class="text-muted">{{ moment().startOf('day').seconds(totalPlayBackTime).format('HH:mm:ss') }}</small>
                    </li>
                    <li class="list-group-item">
                        License used
                        <br>
                        <small class="text-muted">{{ license.licenseCode }}</small>
                    </li>
                    <li class="list-group-item">
                        Related project
                        <br>
                        <small class="text-muted">{{ project.descLong }}</small>
                    </li>
                    <li class="list-group-item">
                        Estimated usage
                    <br>
                    <small class="text-muted" v-if="license.playoutUsageDataEstimation && license.playoutUsageDataEstimation !== -1">Data: {{ license.playoutUsageDataEstimation | formatBytes }}</small><br>
                    <small class="text-muted" v-if="license.playoutUsageTimeEstimation && license.playoutUsageTimeEstimation !== -1">Time: {{ moment().startOf('day').seconds(license.playoutUsageTimeEstimation).format('HH:mm:ss') }}</small>
                    </li>
                </ul>
            </div>

            <div class="col-12">
                <h2 class="h6">Individual sessions</h2>
            </div>

            <div class="col-12">
                <div class="accordion" id="sessions-accordion" >
                    <div class="card" v-for="(session, index) in sessions" :key="index">
                        <div class="card-header" :id="'accordion-heading-' + index">
                            <h2 class="mb-0">
                                <button class="btn btn-link" type="button" data-toggle="collapse" :data-target="'#collapse-session' + index" aria-expanded="true" aria-controls="collapseOne">
                                    Session #{{index + 1}} - {{ moment(session.timeStarted).format('DD.MM.YYYY, HH:mm:ss') }}
                                </button>
                            </h2>
                        </div>

                        <div :id="'collapse-session' + index" class="collapse" :aria-labelledby="'accordion-heading-' + index" data-parent="#sessions-accordion">
                            <div class="card-body">
                                <ul class="list-group list-group-horizontal-md mb-2">
                                    <li class="list-group-item w-50">
                                        <h6 class="mb-1">Player ID</h6>
                                        <p class="text-muted mb-0"><small>{{ session.player }}</small></p>
                                    </li>
                                    <li class="list-group-item w-50">
                                        <h6 class="mb-1">IP Address</h6>
                                        <p class="text-muted mb-0"><small>{{ session.ipAddress }}</small></p>
                                    </li>
                                </ul>
                                <ul class="list-group list-group-horizontal-md">
                                    <li class="list-group-item w-50">
                                        <h6 class="mb-1">User Agent</h6>
                                        <p class="text-muted mb-0"><small>{{ session.userAgent }}</small></p>
                                    </li>
                                    <li class="list-group-item w-50">
                                        <h6 class="mb-1">Playback time</h6>
                                        <p class="text-muted mb-0"><small>{{ moment().startOf('day').seconds(session.playbackTimeTotal).format('HH:mm:ss') }}</small></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </default-layout>
</template>

<script>
    import DefaultLayout from "../components/layout/DefaultLayout";
    import SpinnerComponent from "../components/ui/SpinnerComponent";
    import moment from "moment";

    export default {
        name: "LicenseDetailsPage",
        components: { SpinnerComponent, DefaultLayout },
        computed: {
            license() {
                return this.$store.state.keyNave.license;
            },
            licenseId() {
                let licenseId = null;

                if (Object.prototype.hasOwnProperty.call(this.$route.params, 'licenseId')) {
                    licenseId = this.$route.params.licenseId;
                    licenseId = licenseId ? licenseId : null;
                }

                return licenseId;
            },
            project() {
                return this.$store.state.interactiveLink.project;
            }
        },
        data() {
            return {
                loading: true,
                sessions: [],
                totalPlayBackTime: 0,
                projectId: null
            }
        },
        methods: {
            moment(date) {
                return moment(date);
            },
            parseLogFile() {
                const playoutLogFile = this.license.playoutLogFile;

                if (playoutLogFile.length === 0) {
                    return;
                }

                let sessions = [];
                this.projectId = playoutLogFile[0].payload.project;

                playoutLogFile.forEach(logEntry => {
                    const payload = logEntry.payload;
                    const header = logEntry.header;

                    if (payload.event === 'STREAM_START_PLAYOUT') {
                        sessions.push({
                            timeStarted: header.timestampDateTime,
                            player: payload.player,
                            project: payload.project,
                            ipAddress: payload.clientIpAddress,
                            userAgent: payload.clientUserAgent,
                            playbackTimeTotal: 0,
                            audioTracks: [],
                            subTitleTracks: [],
                            quality: [],
                        });
                    }

                    else if (payload.event === 'STREAM_UPDATE_PLAYOUT') {
                        sessions.forEach(session => {
                            if (session.player === payload.player) {
                                session.playbackTimeTotal = payload.playbackTimeTotal;
                            }
                        });
                    }
                });

                if (sessions.length > 0) {
                    for (var i = 0; i < sessions.length; i++) {
                        this.totalPlayBackTime += parseInt(sessions[i].playbackTimeTotal);
                    }
                }

                this.sessions = sessions;
            }
        },
        async beforeMount() {
            if (this.licenseId !== null) {
                await this.$store.dispatch('keyNave/getLicense', this.licenseId)
                    .then(async () => {
                        await this.parseLogFile();
                    });
            }

            if (this.projectId !== null) {
                await this.$store.dispatch('interactiveLink/getProject', this.projectId);
            }

            this.loading = false;
        }
    }
</script>

<style lang="scss" scoped>

</style>